<template>
  <svg height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.121,15.207l4.086-4.086a1,1,0,0,0,0-1.414L6,2.5H.5V8l7.207,7.207A1,1,0,0,0,9.121,15.207Z"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <polyline fill="none" points="14.5 8 7 0.5 1.5 0.5" stroke-linecap="round" stroke-linejoin="round" />
    <circle cx="4" cy="6" fill="none" r="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
